import { IAddFormPublishTermsResponse } from '../../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { IPaidPublicationState } from '../../../../../reducers/v2';
import { ITariffIdentificator } from '../../../../../reducers/v2/paidPublication/types';
import { ITariffIdentificator as IResponseTariffIdentificator } from '../../../../../repositories/billing-tariffs/entities/Models/TariffIdentificator';
import { defaultTo } from 'ramda';
import { getRestriction } from './getRestriction';

export const mapPaidPublication = (response: IAddFormPublishTermsResponse): IPaidPublicationState => {
  // Может быть null, если мастер запретил субу подачу
  const publicationTariffIdentificator = response.publication?.period?.tariffIdentificator;
  const token = defaultTo('', response.publication?.period?.token);

  return {
    isPaid: Boolean(response.publication?.period?.isPaid),
    days: Number(response.publication?.period?.days),
    highDemandCoefficient: Number(response.highDemandCoefficient),
    autoProlong: response.autoProlong,
    restriction: getRestriction(response.message),
    tariffIdentificator: publicationTariffIdentificator ? mapTariffId(publicationTariffIdentificator) : undefined,
    type: defaultTo(null, response.publication?.period?.type),
    price: Number(response.publication?.period?.price),
    token,
  };
};

function mapTariffId(tariffIdentificator: IResponseTariffIdentificator): ITariffIdentificator {
  const { tariffId, tariffGridType, days, periodType, serviceTypes } = tariffIdentificator;

  return {
    days: defaultTo(0, days),
    periodType,
    serviceTypes: serviceTypes!,
    tariffGridType,
    tariffId,
  };
}
